import React from "react";

function AdminDashboardSkeleton() {
  return (
    <div className="space-y-6">
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className="h-44 animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10"
          />
        ))}
      </div>

      <div className="grid gap-5 xl:grid-cols-[0.8fr_1.2fr]">
        <div className="h-[460px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
        <div className="h-[460px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
      </div>
    </div>
  );
}

export default AdminDashboardSkeleton;